module.exports = __webpack_public_path__ + "img/player-play-blue.05df48fb.svg";